import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { FC } from 'react'
import { TextField } from '@mui/material'

export const FilterCriteriaValueText: FC<FilterCriteriaValueFieldProps> = ({ fieldProps }) => (
  <TextField fullWidth variant="outlined" {...fieldProps} />
)
